var _style, _g, _g2, _defs, _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHummus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BAD1C1;}\n\t.st1{fill:#315CA7;}\n\t.st2{fill:#FED998;}\n\t.st3{fill:none;stroke:#E7BC70;stroke-width:3.4885;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{clip-path:url(#SVGID_2_);fill:#FDCB7C;}\n\t.st5{fill:#FFEBC4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.75,145.03c-47.06,0-53.48-47.19-53.48-59.77h106.96C159.23,91.55,153.07,145.03,105.75,145.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.23,85.43c0,16.41-23.94,29.71-53.48,29.71c-29.54,0-53.48-13.3-53.48-29.71s23.24-10.41,52.78-10.41 C134.58,75.01,159.23,69.02,159.23,85.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.75,110.42c-8.58,0-17.27-1.61-25.44-4.19c-7.51-2.37-15.71-5.76-21.03-11.81 c-4.72-5.36-6.12-16.12,1.16-20.04c2.73-1.47,5.45-1.18,8.41-1.57c4.1-0.55,7.27-2.91,10.59-5.18c4.7-3.21,10.92-2,16.05-4.18 c2.92-1.24,5.14-3.11,6.77-5.69c2.71-4.3,8.75-7.67,12.59-6.96c0,0-2.53,7.15,0.16,11.13c2.68,3.98,6.19,7.6,14.66,8.39 c6.41,0.59,21.79,2.35,24.89,6.55c5.01,6.78,0.05,16.5-5.51,21.05c-6.82,5.58-15.74,8.54-24.23,10.4 C118.56,109.67,112.15,110.42,105.75,110.42"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.43,75.38c-3.45,6.98,1.41,14.48,7.83,17.39c8.69,3.94,18.22,6.03,27.75,6.3 c8.42,0.23,18.26-0.58,25.87-4.51c3.25-1.68,9.6-7.52,7.55-11.74c-1.42-2.92-6.6-2.93-9.29-2.82c-4.22,0.17-8.32,1.31-12.49,1.87 c-11.62,1.55-22.18,2.42-25.5-1.67c-3.32-4.09,1.87-10.76,1.87-10.76"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M147.01,138.82c-2.66-7.29-9.63-15.04-18.34-15.74c-0.1-0.01-0.2-0.01-0.3-0.02 c-0.75-1.59-2.44-2.7-4.42-2.7c-2.63,0-4.76,1.96-4.82,4.4c-0.21,0.09-0.34,0.15-0.34,0.15c-0.51,0.26-2.37,1.21-4.56,3.26 c-1.32,1.23-6.14,5.73-7.6,13.13c-1.48,7.52,0.75,16.9,5.97,19.86c2.69,1.53,5.54,1.63,5.54,1.63c2.05,0.08,3.75-0.45,4.78-0.76 c2.48-0.76,3.39-1.63,5.97-1.95c0.91-0.11,1.65-0.11,2.06-0.11c2.28,0.02,3.66,0.47,4.67,0.65c3.72,0.67,7.14-1.51,7.49-1.74 c2.86-1.87,3.81-4.83,4.45-6.51C149.79,146.45,147.82,141.05,147.01,138.82z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#FED998"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.68,124.05c2.91,0.37,7.7,1.42,12.53,4.68c2.14,1.44,5.78,3.96,8.3,8.79c0.88,1.68,3.2,6.28,2.35,12.17 c-0.58,4.01-2.35,6.75-2.82,7.45c-1.44,2.14-3.08,3.53-4.21,4.35c2.35,0.38,4.71,0.77,7.06,1.15c1.46-0.19,7.49-1.14,11.4-6.33 c3.86-5.14,3.06-11.02,2.66-13.97c-1.19-8.71-6.88-14.13-11.1-18.15c-3.99-3.8-8.9-8.48-15.52-8.32 c-1.49,0.03-5.47,0.13-8.26,3.14C115.41,120.82,114.88,122.9,114.68,124.05z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9917 -0.1289 0.1289 0.9917 -17.7653 16.3843)",
    className: "st5",
    cx: 117.65,
    cy: 145.39,
    rx: 3.26,
    ry: 10.96
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHummus);
export default __webpack_public_path__ + "static/media/Hummus.892f69f552bba24098d6192552ea1687.svg";
export { ForwardRef as ReactComponent };